import React from "react";
import ResumeSection from "./resume";
import SkillSection from "./skills";

function About() {
  return (
    <section data-scroll-index="1">
      <div className="container">
        <div className="row">
          <div className="col-12 center-col margin-70px-bottom sm-margin-40px-bottom xs-margin-30px-bottom text-center">
            <h2 className="font-size34 md-font-size30 sm-font-size26 xs-font-size24 font-weight-700 section-title">
              About Me
            </h2>
          </div>
        </div>
        <div className="row">
          <ResumeSection />
          <SkillSection />
        </div>
      </div>
    </section>
  );
}

export default About;
